module.exports = __webpack_public_path__ + "img/t1-black.d9c95085.png";